/**
 * @generated SignedSource<<74d3deefdac5962eb45a88362c8f3290>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueKey_nativeIssueTable_IssueKeyCell$data = {
  readonly text: string | null | undefined;
  readonly " $fragmentType": "issueKey_nativeIssueTable_IssueKeyCell";
};
export type issueKey_nativeIssueTable_IssueKeyCell$key = {
  readonly " $data"?: issueKey_nativeIssueTable_IssueKeyCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueKey_nativeIssueTable_IssueKeyCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueKey_nativeIssueTable_IssueKeyCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "a94d2309a04ef9d6df8816eb57bf6f4b";

export default node;
